module.exports = __webpack_public_path__ + "static/img/slider3.9ccc1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider3.png
// module id = 8RlX
// module chunks = 1